// @flow
import type { PassengerLibraryState, DriverLibraryState, MerchantLibraryState } from 'reducers/library';

import React, { Component } from 'react';
import DocumentTitle from 'react-document-title';
import { connect } from 'react-redux';

import PassengersTable from 'views/library/passengers/PassengersTable';
import DriversTable from 'views/library/drivers/DriversTable';

import {
  libraryPassengerDelete,
  libraryDriverDelete,
  libraryMerchantDelete,
} from 'actions/library';

import './EntitiesTable.scss';

type Props = {
  passengers: PassengerLibraryState,
  libraryPassengerDelete: Function,

  drivers: DriverLibraryState,
  libraryDriverDelete: Function,

  merchants: MerchantLibraryState,
  libraryMerchantDelete: Function,
};

/* eslint-disable react/prefer-stateless-function */
export class LibraryPage extends Component {
  props: Props;

  render() {
    return (
      <DocumentTitle title="Library">
        <div className="section">
          <div className="container">
            <div className="columns">
              <div className="column">
                <h1 className="title is-2">Library</h1>
                <hr />
                <div className="notification is-warning" role="alert">
                  These entities are templates used when associating a passenger/driver with a
                  cohort. Changes made to these templates will not be reflected in the
                  respective entity in the cohort.
                </div>
              </div>
            </div>
            <div className="columns">
              <div className="column is-half">
                <PassengersTable
                  passengers={this.props.passengers}
                  deletePassenger={this.props.libraryPassengerDelete}
                />
              </div>
              <div className="column is-half">
                <DriversTable
                  drivers={this.props.drivers}
                  deleteDriver={this.props.libraryDriverDelete}
                />
              </div>
            </div>
            {/*
            <div className="columns">
              <div className="column is-half">
                <MerchantsTable
                  merchants={this.props.merchants}
                  deleteMerchant={this.props.libraryMerchantDelete}
                />
              </div>
            </div>
            */}
          </div>
        </div>
      </DocumentTitle>
    );
  }
}

function mapStateToProps(state) {
  return {
    passengers: state.library.passengers,
    drivers: state.library.drivers,
    merchants: state.library.merchants,
  };
}

export default connect(
  mapStateToProps,
  {
    libraryPassengerDelete,
    libraryDriverDelete,
    libraryMerchantDelete,
  }
)(LibraryPage);



/** WEBPACK FOOTER **
 ** ./src/js/views/library/LibraryPage.jsx
 **/